export function shouldEnableServiceWorker(
  isProduction: boolean,
  serverTimingEntries: ReadonlyArray<{ name: string }>
): boolean {
  return (
    isProduction &&
    !serverTimingEntries.some(({ name }) => name === 'ngsw-disabled')
  );
}
